// extracted by mini-css-extract-plugin
export default {"text":"styles_text__6Zva-","paper":"styles_paper__VtbIp","title":"styles_title__yHSxw"};